export class TaskListCharacteristic {
  public readonly id = `${this.taskListType}-${this.taskListGroup}-${this.groupCounter}-${this.nodes}-${this.characteristic}`;

  public constructor(
    public taskListType: string,
    public taskListGroup: string,
    public groupCounter: string,
    public nodes: string,
    public characteristic: string,
    public counter: string,
    public inspectionMethodPlant: string,
    public pmtVersion: string,
    public refMasterInspectionCharacteristic: boolean,
    public plant: string,
    public mkVersion: string,
    public weighting: string,
    public shortText: string,
    public sampleUnit: string,
    public mValidationCode: string,
    public infoField2: string,
    public infoField3: string,
    public shortTextSampleProcedure: string,
    public shortTextInspectionCharacteristic: string,
    public unitOfMeasure: string,
    public baseSampleQuantity: string,
    public client: string,
    public masterInspectionCharacteristics: string,
    public longTextExists: boolean,
    public language: string,
    public samplingProcedure: string,
    public targetValue?: number | string,
    public upperLimit?: number | string,
    public lowerLimit?: number | string,
    public decimalPlaces?: number,
    public firstUpperLimit?: number | string,
    public firstLowerLimit?: number | string
  ) {}
}
